import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { getImagePath } from '@/utils/paths';

const About = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  return (
    <section
      id="about"
      ref={ref}
      className="section-padding bg-white"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Text Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-5xl sm:text-6xl font-light text-gray-900 mb-8">
              MN Médecine
              <br />
              <span className="gradient-text font-normal">Esthétique</span>
            </h2>
            <h3 className="text-2xl font-light text-gray-700 mb-6">
              Une histoire de famille, de science et d'équilibre
            </h3>
            <div className="space-y-6 text-gray-600 leading-relaxed text-lg">
              <p>
                MN Médecine Esthétique est né de l'union de deux frères, deux médecins animés par la
                même passion : Allier science médicale et sens du détail esthétique pour sublimer la
                peau de chacun avec précision, douceur et respect.
              </p>
              <p>
                Le nom "MN" reflète cette dualité fraternelle : les initiales de leurs prénoms,
                symbole d'un projet commun et profondément humain. Mais il porte aussi une
                signification plus intime : en kabyle, "Amane" signifie l'eau, cet élément pur et
                vital qui nettoie, régénère, et accompagne chaque transformation en profondeur.
              </p>
              <p>
                Dans leur cabinet, la technologie de pointe rencontre une approche médicale
                personnalisée. Ici, chaque peau est écoutée, chaque besoin est respecté.
              </p>
              <p>
                Notre cabinet de medecine esthetique a Rouvroy accompagne egalement des patientes et
                patients venant de Lens, Henin-Beaumont et des communes voisines pour des soins
                personnalises en toute securite.
              </p>
              <p className="font-medium text-[#1e3a5f]">
                MN Médecine Esthétique, c'est plus qu'un lieu de soin : c'est un lieu de confiance,
                d'écoute et de beauté responsable, où la médecine devient art, et l'art devient soin.
              </p>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative"
          >
            <div className="relative h-[600px] rounded-3xl overflow-hidden shadow-2xl">
              <img
                src={getImagePath('/images/cabinet1.jpeg')}
                alt="Cabinet de médecine esthétique MN - Clinique moderne et élégante à Rouvroy"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1e3a5f]/20 to-transparent" />
            </div>
            {/* Decorative Element */}
            <motion.div
              animate={{ rotate: 360 }}
              transition={{ duration: 20, repeat: Infinity, ease: 'linear' }}
              className="absolute -bottom-8 -right-8 w-32 h-32 border border-[#1e3a5f]/20 rounded-full"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;